<nav class="w-full h-[56px] bg-[#07122b] flex items-center justify-between px-6 overflow-hidden">
  <div class="flex items-center min-w-0 flex-1">
    <a routerLink="/dashboard" class="mr-8 shrink-0 flex items-center no-underline">
      <img src="/edge-logo.png" alt="EDGE Claims" class="h-[42px] w-auto object-contain" />
    </a>
    <div class="flex items-center gap-2 min-w-0 overflow-hidden">
      @for(l of links; track l.path){
      <a [routerLink]="l.path" routerLinkActive="bg-[#2a2d3f] text-[#FFFFFF]" class="px-3 py-2 rounded-[6px] text-[13px] font-medium
               text-[#94959e] whitespace-nowrap shrink-0
               hover:bg-[#2a2d3f] hover:text-[#FFFFFF]
               transition-all duration-200
               no-underline hover:no-underline">
        {{ l.label }}
      </a>
      }
    </div>
  </div>
  <div class="flex items-center gap-4 ml-6 shrink-0 whitespace-nowrap">
    <!-- <i class="pi pi-search text-[#94959e]  cursor-pointer"></i> -->
    <div class="relative">
      <i class="pi pi-bell text-[#94959e]  cursor-pointer"></i>
      <span class="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full">
      </span>
    </div>
    <!-- <i class="pi pi-cog text-[#94959e]  cursor-pointer"></i> -->
    <div class="flex items-center gap-2 cursor-pointer select-none"
      aria-label="Open profile menu"
      role="button"
      tabindex="0"
      (click)="openProfileMenu($event, profileMenu)"
      (keydown.enter)="openProfileMenu($event, profileMenu)"
      (keydown.space)="$event.preventDefault(); openProfileMenu($event, profileMenu)">
      <div class="w-[34px] h-[34px] rounded-full bg-[linear-gradient(135deg,_#D97706,_#FBBF24)]
               flex items-center justify-center
               text-white font-semibold text-[11px] shrink-0">
        {{ auth.getUser()?.initials }}
      </div>
      <span class="text-[#d3d4d8] font-medium text-[13px] whitespace-nowrap">
        {{ auth.getUser()?.name }}
      </span>
    </div>
  </div>
</nav>
<p-menu #profileMenu [popup]="true" [model]="profileItems" [appendTo]="'body'" styleClass="profile-menu-popup"
  [style]="{ width: profileMenuWidth + 'px' }">
</p-menu>